/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractDeclineModel } from '../models/ContractDeclineModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ContractService {

    /**
     * @param message
     * @param callbackUrl
     * @returns any Success
     * @throws ApiError
     */
    public static contractSignApproveEstateDescription(
        message?: string,
        callbackUrl?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Contract/SignApproveEstateDescription',
            query: {
                'message': message,
                'callbackUrl': callbackUrl,
            },
        });
    }

    /**
     * @param signId
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static contractCollectApproveEstateDescriptionXlent(
        signId?: string,
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Contract/CollectApproveEstateDescriptionXlent',
            query: {
                'signId': signId,
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @returns any Success
     * @throws ApiError
     */
    public static contractBeginApproveEstateDescription(
        sessionId?: string,
        estateId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Contract/BeginApproveEstateDescription',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
            },
        });
    }

    /**
     * @param sessionId
     * @param estateId
     * @param orderReference
     * @returns any Success
     * @throws ApiError
     */
    public static contractCollectApproveEstateDescription(
        sessionId?: string,
        estateId?: string,
        orderReference?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Contract/CollectApproveEstateDescription',
            query: {
                'sessionId': sessionId,
                'estateId': estateId,
                'orderReference': orderReference,
            },
        });
    }

    /**
     * @param orderReference
     * @returns any Success
     * @throws ApiError
     */
    public static contractCancelApproveEstateDescription(
        orderReference?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Contract/CancelApproveEstateDescription',
            query: {
                'orderReference': orderReference,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static contractNotApprovedEstateDescription(
        requestBody?: ContractDeclineModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Contract/NotApprovedEstateDescription',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
